import InternalServerError from 'pages/InternalServerError/InternalServerError';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { Box } from 'style-utils/components/Box';
import Flex from 'style-utils/components/Flex';
import { sayError } from 'utils/functions/say';

const RouterErrorBoundary = () => {
  const error = useRouteError();
  useEffect(() => {
    sayError('Error boundary error: ', error);
  }, []);
  return (
    <Flex w="100%" minH="100vh" flexDirection="column">
      <Box role="heading" aria-level={1} h="4rem" bg="white" />
      <InternalServerError />
      <Box as="footer" h="4rem" bg="bgPrimary" />
    </Flex>
  );
};

export default RouterErrorBoundary;
